function About() {
  return (
    <div>
      <h1>About Us</h1>

      <p>
        <b>HomisCare</b>
        <br />
        <i>Health & Home</i>
      </p>

      <p>
        HomisCare has been serving in the field of
        homeopathy and wellness for over 50 yearsin the name of MOHAN HOMEOPATHIC STORE.

        We provide trusted natural remedies and
        holistic healthcare solutions for various
        health conditions.

        Our mission is to promote safe, effective,
        and affordable healing while improving the
        well-being of our community.
      </p>
    </div>
  );
}

export default About;